import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Divider, Flex, Text } from '@chakra-ui/react';
import { EARLY_CHECKIN_IDS, LATE_CHECKOUT_IDS, HotelBrand } from '@whitbread-eos/api';
import { extrasNamingCheck, formatCurrency, formatDataTestId, formatDate, formatPrice, getExtrasPackagePrice, useSemanticTypography, useCustomLocale } from '@whitbread-eos/utils';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function RoomCardInfo(_ref) {
  var _currentRoom$packages, _currentRoom$packages2;
  var leadGuestTitle = _ref.leadGuestTitle,
    leadGuestName = _ref.leadGuestName,
    roomType = _ref.roomType,
    roomTypeDescription = _ref.roomTypeDescription,
    rateType = _ref.rateType,
    rateTypeDescription = _ref.rateTypeDescription,
    roomGroup = _ref.roomGroup,
    roomReservationEndDate = _ref.roomReservationEndDate,
    roomTotalPrice = _ref.roomTotalPrice,
    roomNumber = _ref.roomNumber,
    ratesPerNight = _ref.ratesPerNight,
    adultMealDescription = _ref.adultMealDescription,
    childrenMealDescription = _ref.childrenMealDescription,
    mealPrice = _ref.mealPrice,
    extrasRoomSelection = _ref.extrasRoomSelection,
    packagesExtrasItems = _ref.packagesExtrasItems,
    currency = _ref.currency,
    taxesMessage = _ref.taxesMessage,
    brand = _ref.brand,
    currentLang = _ref.currentLang,
    t = _ref.t;
  var baseDataTestId = formatDataTestId('RoomCardInfo', "room".concat(roomNumber));
  var leftId = str => formatDataTestId('LeftColumn', str);
  var rightId = str => formatDataTestId('RightColumn', str);
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language;
  var getTypographyProps = useSemanticTypography();
  var currentRoom = extrasRoomSelection === null || extrasRoomSelection === void 0 ? void 0 : extrasRoomSelection[roomNumber - 1];
  var extrasLabelCheck = extrasId => currentRoom === null || currentRoom === void 0 ? void 0 : currentRoom.packagesSelection.some(extrasPackage => {
    var _extrasPackage$id;
    return extrasPackage === null || extrasPackage === void 0 || (_extrasPackage$id = extrasPackage.id) === null || _extrasPackage$id === void 0 ? void 0 : _extrasPackage$id.includes(extrasId);
  });
  return _jsxs(Box, {
    "data-testid": baseDataTestId,
    p: "lg",
    pt: 0,
    children: [_jsxs(Flex, _objectSpread(_objectSpread({}, columnsStyle), {}, {
      children: [_jsxs(Box, _objectSpread(_objectSpread({
        "data-testid": formatDataTestId(baseDataTestId, leftId('Main'))
      }, leftColumnStyle), {}, {
        children: [_jsxs(Box, _objectSpread(_objectSpread({}, leftColBoxStyle), {}, {
          children: [_jsx(Text, _objectSpread(_objectSpread({
            "data-testid": formatDataTestId(baseDataTestId, leftId('LeadGuest-Label'))
          }, getTypographyProps(leadGuestLabelLegacyTypography, leadGuestLabelSemanticTypography)), {}, {
            children: t('booking.confirmation.leadGuest')
          })), _jsxs(Text, _objectSpread(_objectSpread({
            "data-testid": formatDataTestId(baseDataTestId, leftId('LeadGuest-Name'))
          }, getTypographyProps(leadGuestNameLegacyTypography, leadGuestNameSemanticTypography)), {}, {
            className: "sessioncamhidetext assist-no-show",
            children: [leadGuestTitle, " ", leadGuestName]
          }))]
        })), _jsxs(Box, _objectSpread(_objectSpread({}, leftColBoxStyle), {}, {
          children: [_jsx(Text, _objectSpread(_objectSpread({
            "data-testid": formatDataTestId(baseDataTestId, leftId('RoomLabel'))
          }, getTypographyProps(roomLabelLegacyTypography, roomLabelSemanticTypography)), {}, {
            children: t('booking.confirmation.yourRoom')
          })), _jsxs(Text, _objectSpread(_objectSpread({
            "data-testid": formatDataTestId(baseDataTestId, leftId('RoomDetails'))
          }, getTypographyProps({}, roomDetailsSemanticTypography)), {}, {
            children: [_jsx(Text, {
              as: "b",
              children: roomType
            }), roomTypeDescription && " - ".concat(roomTypeDescription)]
          }))]
        })), _jsxs(Box, _objectSpread(_objectSpread({}, leftColBoxStyle), {}, {
          children: [_jsx(Text, _objectSpread(_objectSpread({
            "data-testid": formatDataTestId(baseDataTestId, leftId('RoomRate-Label'))
          }, getTypographyProps(roomRateLabelLegacyTypography, roomRateLabelSemanticTypography)), {}, {
            children: t('booking.confirmation.yourRate')
          })), _jsxs(Text, _objectSpread(_objectSpread({
            "data-testid": formatDataTestId(baseDataTestId, leftId('RoomRate-Details'))
          }, getTypographyProps({}, roomRateDetailsSemanticTypography)), {}, {
            children: [_jsx(Text, {
              as: "b",
              children: "".concat(brand === HotelBrand.HUB ? 'hub' : '', " ").concat(rateType)
            }), " -", ' ', rateTypeDescription]
          }))]
        })), _jsxs(Box, _objectSpread(_objectSpread({}, leftColBoxStyle), {}, {
          children: [_jsx(Text, _objectSpread(_objectSpread({
            "data-testid": formatDataTestId(baseDataTestId, leftId('RoomGroup-Label'))
          }, getTypographyProps(roomGroupLabelLegacyTypography, roomGroupLabelSemanticTypography)), {}, {
            children: t('booking.confirmation.yourGroup')
          })), _jsx(Text, _objectSpread(_objectSpread({
            "data-testid": formatDataTestId(baseDataTestId, leftId('RoomGroup-Details'))
          }, getTypographyProps({}, roomGroupDetailsSemanticTypography)), {}, {
            children: roomGroup
          }))]
        }))]
      })), _jsxs(Flex, _objectSpread(_objectSpread({
        "data-testid": formatDataTestId(baseDataTestId, rightId('Main'))
      }, rightColumnStyle), {}, {
        children: [_jsxs(Box, {
          w: "full",
          children: [_jsx(Text, _objectSpread(_objectSpread({
            "data-testid": formatDataTestId(baseDataTestId, rightId('Arrival-Label'))
          }, getTypographyProps(arrivalLabelLegacyTypography, arrivalLabelSemanticTypography)), {}, {
            children: t('booking.hotel.summary.arriving')
          })), ratesPerNight === null || ratesPerNight === void 0 ? void 0 : ratesPerNight.map((night, index) => {
            var _night$pricePerNight, _night$cityTaxPerNigh;
            return _jsxs(Flex, {
              direction: "column",
              "data-testid": formatDataTestId(baseDataTestId, rightId("RatePerNight-".concat(index))),
              children: [_jsxs(Flex, {
                justifyContent: "space-between",
                alignItems: "center",
                children: [_jsx(Text, _objectSpread(_objectSpread(_objectSpread({}, arrivalDayLayoutStyles), getTypographyProps(arrivalDayLegacyTypography, arrivalDaySemanticTypography)), {}, {
                  "data-testid": formatDataTestId(baseDataTestId, rightId("Arrival-Day-".concat(index))),
                  children: formatDate(night.startDate, 'eeee', currentLang)
                })), index === 0 && _jsx(Text, _objectSpread(_objectSpread(_objectSpread({
                  "data-testid": formatDataTestId(baseDataTestId, rightId('Arrival-Checkin'))
                }, arrivalCheckinLayoutStyles), getTypographyProps(arrivalCheckinLegacyTypography, arrivalCheckinSemanticTypography)), {}, {
                  textAlign: "right",
                  children: EARLY_CHECKIN_IDS.some(id => extrasLabelCheck(id)) ? t('ancillaries.booking.summary.checkin') : t('booking.confirmation.checkinTime')
                }))]
              }), _jsxs(Flex, {
                justify: "space-between",
                alignItems: "center",
                "data-testid": formatDataTestId(baseDataTestId, rightId("Room-PricePerNight-".concat(index))),
                children: [_jsx(Text, _objectSpread(_objectSpread({
                  "data-testid": formatDataTestId(baseDataTestId, rightId('Leaving-Date')),
                  color: "darkGrey2"
                }, getTypographyProps(arrivalDateLegacyTypography, arrivalDateSemanticTypography)), {}, {
                  children: language === 'en' ? formatDate(night.startDate, 'd MMM yyyy', currentLang) : formatDate(night.startDate, 'E dd MMM yyyy', currentLang)
                })), _jsx(Text, _objectSpread(_objectSpread({
                  "data-testid": formatDataTestId(baseDataTestId, rightId('PricePerNight-CityTax'))
                }, getTypographyProps(arrivalPriceLegacyTypography, arrivalPriceSemanticTypography)), {}, {
                  children: formatPrice(formatCurrency(currency), (((_night$pricePerNight = night === null || night === void 0 ? void 0 : night.pricePerNight) !== null && _night$pricePerNight !== void 0 ? _night$pricePerNight : 0) + ((_night$cityTaxPerNigh = night === null || night === void 0 ? void 0 : night.cityTaxPerNight) !== null && _night$cityTaxPerNigh !== void 0 ? _night$cityTaxPerNigh : 0)).toFixed(2), language)
                }))]
              }), _jsx(Divider, _objectSpread({}, dividerStyle))]
            }, "".concat(night.startDate, "-").concat(index));
          })]
        }), _jsxs(Box, {
          w: "full",
          children: [_jsx(Text, _objectSpread(_objectSpread({
            "data-testid": formatDataTestId(baseDataTestId, rightId('Leaving-Label'))
          }, getTypographyProps(leavingLabelLegacyTypography, leavingLabelSemanticTypography)), {}, {
            children: t('booking.hotel.summary.checkout')
          })), _jsxs(Flex, {
            justifyContent: "space-between",
            alignItems: "center",
            children: [_jsx(Text, _objectSpread(_objectSpread(_objectSpread({
              "data-testid": formatDataTestId(baseDataTestId, rightId('Leaving-Day'))
            }, leavingDayLayoutStyles), getTypographyProps(leavingDayLegacyTypography, leavingDaySemanticTypography)), {}, {
              children: formatDate(roomReservationEndDate, 'eeee', currentLang)
            })), _jsx(Text, _objectSpread(_objectSpread(_objectSpread({
              "data-testid": formatDataTestId(baseDataTestId, rightId('Leaving-CheckOut'))
            }, leavingCheckoutLayoutStyles), getTypographyProps(leavingCheckoutLegacyTypography, leavingCheckoutSemanticTypography)), {}, {
              textAlign: "right",
              children: LATE_CHECKOUT_IDS.some(id => extrasLabelCheck(id)) ? t('ancillaries.booking.summary.checkout') : t('booking.confirmation.checkoutTime')
            }))]
          }), _jsx(Text, _objectSpread(_objectSpread({
            "data-testid": formatDataTestId(baseDataTestId, rightId('Leaving-Date')),
            color: "darkGrey2"
          }, getTypographyProps(leavingDateLegacyTypography, leavingDateSemanticTypography)), {}, {
            children: language === 'en' ? formatDate(roomReservationEndDate, 'd MMM yyyy', currentLang) : formatDate(roomReservationEndDate, 'E dd MMM yyyy', currentLang)
          }))]
        }), currentRoom && (currentRoom === null || currentRoom === void 0 || (_currentRoom$packages = currentRoom.packagesSelection) === null || _currentRoom$packages === void 0 ? void 0 : _currentRoom$packages.length) > 0 && _jsxs(_Fragment, {
          children: [_jsx(Divider, _objectSpread({}, dividerStyle)), _jsxs(Box, {
            w: "full",
            children: [_jsx(Text, {
              "data-testid": formatDataTestId(baseDataTestId, rightId('Extras-Label')),
              fontWeight: "bold",
              fontSize: "md",
              children: t('account.dashboard.extras')
            }), currentRoom === null || currentRoom === void 0 || (_currentRoom$packages2 = currentRoom.packagesSelection) === null || _currentRoom$packages2 === void 0 ? void 0 : _currentRoom$packages2.map(roomExtras => {
              var id = roomExtras.id;
              var extrasLabelsCheck = "".concat(extrasNamingCheck(t, id));
              return _jsxs(Flex, {
                justifyContent: "space-between",
                alignItems: "center",
                children: [_jsx(Text, _objectSpread(_objectSpread({
                  "data-testid": formatDataTestId(baseDataTestId, rightId("".concat(extrasLabelsCheck)))
                }, extrasRoomStyle), {}, {
                  children: extrasLabelsCheck
                })), _jsx(Text, {
                  "data-testid": formatDataTestId(baseDataTestId, rightId('Extras-Price')),
                  textAlign: "right",
                  extrasRoomStyle,
                  fontWeight: 'bold',
                  fontSize: 'xl',
                  children: id && getExtrasPackagePrice(id, language, packagesExtrasItems)
                })]
              }, id);
            })]
          })]
        }), (adultMealDescription.length > 0 || childrenMealDescription.length > 0) && _jsxs(_Fragment, {
          children: [_jsx(Divider, _objectSpread({}, dividerStyle)), _jsxs(Box, {
            w: "full",
            children: [_jsx(Text, {
              "data-testid": formatDataTestId(baseDataTestId, rightId('Meals-Label')),
              fontWeight: "bold",
              fontSize: "md",
              children: t('booking.hotel.summary.meals')
            }), _jsxs(Flex, {
              justifyContent: "space-between",
              alignItems: "flex-end",
              children: [_jsxs(Flex, {
                direction: "column",
                children: [adultMealDescription.length > 0 && adultMealDescription.map(adultMealItem => _jsx(Text, {
                  "data-testid": formatDataTestId(baseDataTestId, rightId('Meals-Adults')),
                  fontWeight: "medium",
                  fontSize: "md",
                  children: adultMealItem
                }, "adultMealItem-".concat(adultMealItem))), childrenMealDescription.length > 0 && childrenMealDescription.map(childrenMealItem => _jsx(Text, {
                  "data-testid": formatDataTestId(baseDataTestId, rightId('Meals-Children')),
                  fontWeight: "medium",
                  fontSize: "md",
                  children: childrenMealItem
                }, "childrenMealItem-".concat(childrenMealItem)))]
              }), _jsx(Text, {
                "data-testid": formatDataTestId(baseDataTestId, rightId('Meals-Cost')),
                fontWeight: "bold",
                fontSize: "xl",
                children: formatPrice(formatCurrency(currency), mealPrice.toFixed(2), language)
              })]
            })]
          })]
        })]
      }))]
    })), _jsxs(Flex, {
      justifyContent: "flex-end",
      fontSize: "xl",
      mt: "md",
      children: [_jsx(Text, _objectSpread(_objectSpread({
        "data-testid": formatDataTestId(baseDataTestId, rightId('RoomTotalPrice-Label')),
        mr: "sm"
      }, getTypographyProps({}, roomTotalPriceLabelSemanticTypography)), {}, {
        children: t('booking.confirmation.roomTotalMD').replace('[roomNumber]', roomNumber.toString())
      })), _jsx(Text, _objectSpread(_objectSpread({
        "data-testid": formatDataTestId(baseDataTestId, rightId('RoomTotalPrice-Amount'))
      }, getTypographyProps(roomTotalPriceAmountLegacyTypography, roomTotalPriceAmountSemanticTypography)), {}, {
        children: formatPrice(formatCurrency(currency), roomTotalPrice.toFixed(2), language)
      }))]
    }), !!(taxesMessage !== null && taxesMessage !== void 0 && taxesMessage.length) && _jsx(Flex, _objectSpread(_objectSpread({
      justifyContent: "flex-end"
    }, infoTextStyle), {}, {
      "data-testid": formatDataTestId(baseDataTestId, 'CityTaxMessage'),
      children: taxesMessage
    }))]
  });
}
var leftColBoxStyle = {
  mb: 'xl'
};
var leadGuestLabelLegacyTypography = {
  fontWeight: 'bold',
  fontSize: 'md'
};
var leadGuestLabelSemanticTypography = {
  textStyle: 'body-m-emphasis'
};
var leadGuestNameLegacyTypography = {
  fontSize: 'lg'
};
var leadGuestNameSemanticTypography = {
  textStyle: 'body-m-regular'
};
var roomLabelLegacyTypography = {
  fontWeight: 'bold',
  fontSize: 'md'
};
var roomLabelSemanticTypography = {
  textStyle: 'body-m-emphasis'
};
var roomDetailsSemanticTypography = {
  textStyle: 'body-m-emphasis'
};
var roomRateLabelLegacyTypography = {
  fontWeight: 'bold',
  fontSize: 'md'
};
var roomRateLabelSemanticTypography = {
  textStyle: 'body-m-emphasis'
};
var roomRateDetailsSemanticTypography = {
  textStyle: 'body-m-regular'
};
var roomGroupLabelLegacyTypography = {
  fontWeight: 'bold',
  fontSize: 'md'
};
var roomGroupLabelSemanticTypography = {
  textStyle: 'body-m-emphasis'
};
var roomGroupDetailsSemanticTypography = {
  textStyle: 'body-m-regular'
};
var arrivalLabelLegacyTypography = {
  fontWeight: 'bold',
  fontSize: 'md'
};
var arrivalLabelSemanticTypography = {
  textStyle: 'body-m-emphasis'
};
var arrivalDayLayoutStyles = {
  color: 'btnSecondaryEnabled'
};
var arrivalDayLegacyTypography = {
  fontWeight: 'semibold',
  fontSize: 'lg'
};
var arrivalDaySemanticTypography = {
  textStyle: 'body-m-regular'
};
var arrivalCheckinLayoutStyles = {
  w: {
    sm: 'full',
    xs: '7.875rem',
    mobile: '6.125rem'
  }
};
var arrivalCheckinLegacyTypography = {
  fontWeight: 'medium',
  fontSize: 'md'
};
var arrivalCheckinSemanticTypography = {
  textStyle: 'body-m-regular'
};
var arrivalDateLegacyTypography = {
  fontWeight: 'medium',
  fontSize: 'md'
};
var arrivalDateSemanticTypography = {
  textStyle: 'body-m-regular'
};
var arrivalPriceLegacyTypography = {
  fontSize: 'xl',
  fontWeight: 'bold'
};
var arrivalPriceSemanticTypography = {
  textStyle: 'body-m-emphasis'
};
var leavingLabelLegacyTypography = {
  fontWeight: 'bold',
  fontSize: 'md'
};
var leavingLabelSemanticTypography = {
  textStyle: 'body-m-emphasis'
};
var leavingDayLayoutStyles = {
  color: 'btnSecondaryEnabled'
};
var leavingDayLegacyTypography = {
  fontWeight: 'semibold',
  fontSize: 'lg'
};
var leavingDaySemanticTypography = {
  textStyle: 'body-m-regular'
};
var leavingCheckoutLayoutStyles = {
  w: {
    sm: 'full',
    xs: '7.875rem',
    mobile: '6.125rem'
  }
};
var leavingCheckoutLegacyTypography = {
  fontWeight: 'medium',
  fontSize: 'md'
};
var leavingCheckoutSemanticTypography = {
  textStyle: 'body-m-regular'
};
var leavingDateLegacyTypography = {
  fontWeight: 'medium',
  fontSize: 'md'
};
var leavingDateSemanticTypography = {
  textStyle: 'body-m-regular'
};
var roomTotalPriceLabelSemanticTypography = {
  textStyle: 'body-l-regular'
};
var roomTotalPriceAmountLegacyTypography = {
  fontWeight: 'bold'
};
var roomTotalPriceAmountSemanticTypography = {
  textStyle: 'body-l-emphasis'
};
var rightColumnStyle = {
  w: {
    xl: '33.5rem',
    mobile: 'full'
  },
  backgroundColor: 'lightGrey5',
  p: 'lg',
  direction: 'column',
  h: 'fit-content',
  mb: {
    xl: '0',
    mobile: '2xl'
  }
};
var dividerStyle = {
  my: 'sm',
  borderColor: 'lightGrey3'
};
var columnsStyle = {
  justifyContent: 'space-between',
  direction: {
    xl: 'row',
    mobile: 'column'
  }
};
var leftColumnStyle = {
  w: {
    xl: '12.5rem',
    mobile: 'full'
  },
  mb: {
    xl: '0',
    mobile: '3xl'
  }
};
var infoTextStyle = {
  justifyContent: 'flex-end',
  fontWeight: 'medium',
  lineHeight: '2',
  color: 'darkGrey1',
  fontSize: 'sm'
};
var extrasRoomStyle = {
  fontWeight: 'medium',
  fontSize: 'md',
  w: {
    sm: 'full',
    xs: '7.875rem',
    mobile: '6.125rem'
  }
};